import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeader: {
    description: 'Header for Modal to invite new Vendors to connect',
    defaultMessage: 'Invite Vendor',
    id: '46+QGt',
  },
  inviteVendorModalBodyText: {
    description: 'Info message describing how to invite vendors.',
    defaultMessage:
      'Invite your Vendor(s) to connect their ShipStation account to yours. We will send them an invitation via email. Once they accept, you will be notified and can begin sending fulfillment orders.',
    id: 'XSOKiN',
  },
  companyNameLabel: {
    description: 'Input box to specify name client would like Vendor to see them as.',
    defaultMessage: 'Vendor-Facing Company Name',
    id: 'mt+tdn',
  },
  vendorNicknameLabel: {
    description: 'Input box to specify nickname for Vendor Connection.',
    defaultMessage: 'Vendor Nickname',
    id: 'sdZQvA',
  },
  emailLabel: {
    description: 'Input box to enter email invitation will be sent to.',
    defaultMessage: 'Email',
    id: 'JbFdmH',
  },
  addVendorRow: {
    description: 'Button that allows user to add a new row of vendor.',
    defaultMessage: 'Add Vendor',
    id: 'L9zWLN',
  },
  sublabel: {
    description: 'Sublabel describing what a Vendor-Facing Company Name is',
    defaultMessage: 'The name Vendors will see when they associate with your company.',
    id: 'NHFy7I',
  },
  duplicateEmailError: {
    description: 'Error message to let the user know the email they entered has already been invited',
    defaultMessage: 'You have already sent a pending invite to this email',
    id: 'pTFhrw',
  },
  duplicateNicknameError: {
    description: 'Error message to let the user know the Nickname they entered is already in use',
    defaultMessage: 'This nickname is already in use',
    id: 'n9h2/0',
  },
  emptyNicknameError: {
    description: 'Error message to let the user know the Nickname field is required and cannot be empty',
    defaultMessage: 'Nickname must not be empty',
    id: 'ZWxWf5',
  },
  invalidEmailError: {
    description: 'Error message to let the user know their email format was incorrect.',
    defaultMessage: 'Enter your email in this format: yourname@example.com',
    id: 'qXEHbI',
  },
  continueButtonText: {
    description: 'Button text to send email invites to vendors',
    defaultMessage: 'Send Invite',
    id: '/5Zjv3',
  },
  inviteVendorNotificationTitle: {
    description: 'Title for notification stating result of invite.',
    defaultMessage: 'Vendor Invite',
    id: 'DAI3L7',
  },
  inviteVendorNotificationProcessing: {
    description: 'Notification text stating we are sending an invite.',
    defaultMessage: 'Sending Invite...',
    id: 'Z7OIPm',
  },
  inviteVendorNotificationErrorTitle: {
    description: 'Title for notification when we encounter an error.',
    defaultMessage: 'Vendor invite not sent',
    id: 'L8VSQm',
  },
  inviteVendorNotificationError: {
    description: 'Notification text stating we had an error while sending an invite.',
    defaultMessage: 'System error on our side. Please resend the invite.',
    id: 'pBNtig',
  },
  inviteVendorNotificationSuccessTitle: {
    description: 'Title for notification stating result of invite.',
    defaultMessage: 'Vendor invited',
    id: 'u72UPa',
  },
  inviteVendorNotificationSuccess: {
    description: 'Notification text stating we have successfully sent an invite.',
    defaultMessage: 'We sent your email invite to the Vendor. Your connection is pending their approval.',
    id: 'tsxZnY',
  },
});
